import { createI18n } from 'vue-i18n'
import pl from './pl.json'
import en from './en.json'

const i18n = createI18n({
    locale: localStorage.getItem('lang') as string ?? 'pl',
    legacy: false, // disable legacy API
    messages: { pl, en },
    warnHtmlInMessage: 'off'
})
export default i18n